/* esm.sh - trough@2.2.0 */
export * from "/*trough@2.2.0/esnext/trough.mjs";
